export const MuiCard = {
  styleOverrides: {
    root: {
      boxShadow: "",
    },
  },
};
